// ==================================================
// INITIALIZERS
// ==================================================

function setEventListeners() {
    Array.from(document.getElementsByClassName('js--pd-modal-close')).forEach((k) =>
        k.addEventListener('click', (e) => handleCloseBtn(e)),
    );
}

// ==================================================
// HANDLERS
// ==================================================

function handleCloseBtn(e) {
    e.preventDefault();
    toggleModal(e.target.closest('.js--pd-modal'));
}

// ==================================================
// HELPERS
// ==================================================

export function toggleModal(el = null, display = false) {
    const modal = el || document.getElementsByClassName('js--pd-modal')[0];
    const containers = Array.from(modal.querySelectorAll('.js--modal-overlay, .pd-modal'));

    if (!display) {
        return containers.forEach((k) => {
            const { classList } = k;

            classList.add('pd-modal--fadeOut');
            setTimeout(() => classList.add('pd-modal--hidden'), 205);
        });
    }

    containers.forEach((k) => {
        const { classList } = k;

        classList.remove('pd-modal--hidden');
        setTimeout(() => classList.remove('pd-modal--fadeOut'), 1);
    });
}

// ==================================================
// INIT
// ==================================================

function init() {
    setEventListeners();
}

export default init;
